import React, { useContext, useState } from "react";
import AdminInterestContext from "../../context/adminInterest/adminInterestContext";
import * as GrIcons from "react-icons/gr";

const SiteItem = ({ data, setSite, selectedSite }) => {
  const {
    name,
    charter,
    address: { state, address_1, city, zip },
  } = data;
  return (
    <tr>
      <td>{name}</td>
      <td>{charter}</td>
      <td>{`${address_1}, ${city}, ${state}, ${zip}`}</td>
      {Object.keys(selectedSite).length === 0 && (
        <td>
          <div
            onClick={() => {
              setSite(data);
            }}
            className="btn btn-llac-light-grey"
          >
            Select
          </div>
        </td>
      )}
    </tr>
  );
};

const SiteFieldSearchModal = ({ formData, setFormData }) => {
  const [search, setSearch] = useState("");
  const [selectedSite, setSelectedSite] = useState("");
  const adminInterestContext = useContext(AdminInterestContext);
  const {
    setFormModal,
    filteresSearchSites,
    filterSearchSites,
    clearfilteredSearchSites,
  } = adminInterestContext;

  return (
    <div id="site-field-search-modal" className="modal">
      <div className="field-modal-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("siteFieldSearchModal", false)}
          />
          <h2>Search Sites by Fields</h2>
        </div>
        <div className="modal-body">
          <div className="search-bar form">
            <input
              type="search"
              value={search}
              placeholder="Search Sites by Fields"
              onChange={(e) => {
                if (e.target.value == "") {
                  clearfilteredSearchSites();
                } else {
                  filterSearchSites(e.target.value);
                }
                setSearch(e.target.value);
                setSelectedSite({});
              }}
            />
          </div>
          <div className="search-results">
            <table>
              <tr>
                <th>Name</th>
                <th>Charter</th>
                <th>Address</th>
                {Object.keys(selectedSite).length === 0 && <th>Action</th>}
              </tr>
              {filteresSearchSites.length > 0 ? (
                Object.keys(selectedSite).length !== 0 ? (
                  <SiteItem
                    data={selectedSite}
                    setSite={setSelectedSite}
                    selectedSite={selectedSite}
                  />
                ) : (
                  filteresSearchSites.map((item) => {
                    return (
                      <SiteItem
                        data={item}
                        setSite={setSelectedSite}
                        selectedSite={selectedSite}
                      />
                    );
                  })
                )
              ) : null}
            </table>
          </div>
        </div>
        <div className="bottom-bar">
          <div className="btns">
            {Object.keys(selectedSite).length !== 0 && (
              <div
                onClick={() => {
                  setSearch("");
                  clearfilteredSearchSites();
                  setFormData({
                    ...formData,
                    learningCenterId: selectedSite.id,
                    learningCenterName: selectedSite.name,
                    learningCenterCharter: selectedSite.charter,
                    learningCenterAddress: `${selectedSite.address.address_1}, ${selectedSite.address.city}, ${selectedSite.address.state}, ${selectedSite.address.zip}`,
                    learningCenterCoordinates: selectedSite.address.coordinates,
                  });
                  setFormModal("siteFieldSearchModal", false);
                }}
                className={`btn btn-llac-dark-green`}
              >
                Confirm Site
              </div>
            )}
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("siteFieldSearchModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteFieldSearchModal;
